import { createSharedComposable, useBreakpoints } from '@vueuse/core';
import * as breakpoints from '../../breakpoints';
import { reactive } from 'vue';

export { useAppBreakpoints };

const useAppBreakpoints = createSharedComposable(() => {
  const bp = useBreakpoints(breakpoints.DEFAULT);

  return reactive({
    atMobiles: bp.between('mobiles', 'mobile'),
    atMobile: bp.between('mobile', 'mobilel'),
    atMobilel: bp.between('mobilel', 'tablet'),
    atTablet: bp.between('tablet', 'tabletl'),
    atTabletl: bp.between('tabletl', 'laptop'),
    atLaptop: bp.between('laptop', 'laptopl'),
    atLaptopl: bp.between('laptopl', 'desktop'),
    atDesktop: bp.between('desktop', 'desktop1k'),
    atDesktop1k: bp.between('desktop1k', 'desktop2k'),
    atDesktop2k: bp.greaterOrEqual('desktop2k'),

    ltMobiles: bp.smaller('mobiles'),
    ltMobile: bp.smaller('mobile'),
    ltMobilel: bp.smaller('mobilel'),
    ltTablet: bp.smaller('tablet'),
    ltTabletl: bp.smaller('tabletl'),
    ltLaptop: bp.smaller('laptop'),
    ltLaptopl: bp.smaller('laptopl'),
    ltDesktop: bp.smaller('desktop'),
    ltDesktop1k: bp.smaller('desktop1k'),
    ltDesktop2k: bp.smaller('desktop2k'),

    mobiles: bp.greaterOrEqual('mobiles'),
    mobile: bp.greaterOrEqual('mobile'),
    mobilel: bp.greaterOrEqual('mobilel'),
    tablet: bp.greaterOrEqual('tablet'),
    tabletl: bp.greaterOrEqual('tabletl'),
    laptop: bp.greaterOrEqual('laptop'),
    laptopl: bp.greaterOrEqual('laptopl'),
    desktop: bp.greaterOrEqual('desktop'),
    desktop1k: bp.greaterOrEqual('desktop1k'),
    desktop2k: bp.greaterOrEqual('desktop2k'),
  });
});
